import React from 'react';
import ReactDOM from 'react-dom';
import { ErrorBoundary } from '@react-shared/components';
import Page from '@services/containers/Page';

const renderServiceDirectory = (element) => {
  const data = $(element).data('services-data');

  ReactDOM.render(
    <ErrorBoundary
      errorPage={data.errorPage}
      filters={data.filters}
      tier={data.tier}
      logErrorPath={data.logErrorPath}
      pageId={data.id}
      pageSlug={data.productLandingPageSlug}
      pageType="service"
    >
      <Page {...data} />
    </ErrorBoundary>,
    element
  );
};

$('html').on('consumer.dependencies.loaded', () => {
  const servicesDirectoryElement = document.getElementById('services-directory');
  if (servicesDirectoryElement) renderServiceDirectory(servicesDirectoryElement);
});
